/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AuditResponse,
  KioskPictureRequest,
  KioskRequest,
  KioskRequestWithFiles,
  KioskResponse,
  KioskStatusRequest,
  LeasingClientRequest,
  LeasingClientResponse,
  LeasingClientsRequest,
  PageResponseKioskResponse,
  PageResponseLeasingClientResponse,
  RentalAuthorizationRequest,
  RentalContractRequest,
  RentalRequests,
  RentalRequestWithFiles,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Leasing<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags kiosk-controller
   * @name AddKiosk
   * @request POST:/leasing/kiosks
   * @secure
   * @response `200` `KioskResponse` OK
   */
  addKiosk = (data: KioskRequestWithFiles, params: RequestParams = {}) =>
    this.request<KioskResponse, any>({
      path: `/leasing/kiosks`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags kiosk-controller
   * @name AddRental
   * @request POST:/leasing/kiosks/{kioskId}/rentals
   * @secure
   * @response `200` `KioskResponse` OK
   */
  addRental = (
    kioskId: string,
    data: RentalRequestWithFiles,
    params: RequestParams = {},
  ) =>
    this.request<KioskResponse, any>({
      path: `/leasing/kiosks/${kioskId}/rentals`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags kiosk-controller
   * @name DeleteRentals
   * @request DELETE:/leasing/kiosks/{kioskId}/rentals
   * @secure
   * @response `200` `KioskResponse` OK
   */
  deleteRentals = (
    kioskId: string,
    data: RentalRequests,
    params: RequestParams = {},
  ) =>
    this.request<KioskResponse, any>({
      path: `/leasing/kiosks/${kioskId}/rentals`,
      method: "DELETE",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags kiosk-controller
   * @name RenewRental
   * @request POST:/leasing/kiosks/{id}/rentals/renewal
   * @secure
   * @response `200` `KioskResponse` OK
   */
  renewRental = (
    id: string,
    data: RentalRequestWithFiles,
    params: RequestParams = {},
  ) =>
    this.request<KioskResponse, any>({
      path: `/leasing/kiosks/${id}/rentals/renewal`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags kiosk-controller
   * @name ListKiosks
   * @request POST:/leasing/kiosks/getKiosks
   * @secure
   * @response `200` `PageResponseKioskResponse` OK
   */
  listKiosks = (data: KioskRequest, params: RequestParams = {}) =>
    this.request<PageResponseKioskResponse, any>({
      path: `/leasing/kiosks/getKiosks`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags leasing-client-controller
   * @name AddLeasingClient
   * @request POST:/leasing/clients
   * @secure
   * @response `200` `LeasingClientResponse` OK
   */
  addLeasingClient = (data: LeasingClientRequest, params: RequestParams = {}) =>
    this.request<LeasingClientResponse, any>({
      path: `/leasing/clients`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags leasing-client-controller
   * @name ListLeasingClients
   * @request POST:/leasing/clients/getClients
   * @secure
   * @response `200` `PageResponseLeasingClientResponse` OK
   */
  listLeasingClients = (
    data: LeasingClientsRequest,
    params: RequestParams = {},
  ) =>
    this.request<PageResponseLeasingClientResponse, any>({
      path: `/leasing/clients/getClients`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags kiosk-controller
   * @name GetKioskById
   * @summary Get Leasing Kiosks by ID
   * @request GET:/leasing/kiosks/{kioskId}
   * @secure
   * @response `200` `KioskResponse` OK
   */
  getKioskById = (kioskId: string, params: RequestParams = {}) =>
    this.request<KioskResponse, any>({
      path: `/leasing/kiosks/${kioskId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags kiosk-controller
   * @name DeleteKiosk
   * @request DELETE:/leasing/kiosks/{kioskId}
   * @secure
   * @response `200` `KioskResponse` OK
   */
  deleteKiosk = (kioskId: string, params: RequestParams = {}) =>
    this.request<KioskResponse, any>({
      path: `/leasing/kiosks/${kioskId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags kiosk-controller
   * @name UpdateKiosk
   * @request PATCH:/leasing/kiosks/{kioskId}
   * @secure
   * @response `200` `KioskResponse` OK
   */
  updateKiosk = (
    kioskId: string,
    data: KioskRequestWithFiles,
    params: RequestParams = {},
  ) =>
    this.request<KioskResponse, any>({
      path: `/leasing/kiosks/${kioskId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags kiosk-controller
   * @name DeleteRental
   * @request DELETE:/leasing/kiosks/{kioskId}/rentals/{rentalId}
   * @secure
   * @response `200` `KioskResponse` OK
   */
  deleteRental = (
    kioskId: string,
    rentalId: string,
    params: RequestParams = {},
  ) =>
    this.request<KioskResponse, any>({
      path: `/leasing/kiosks/${kioskId}/rentals/${rentalId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags kiosk-controller
   * @name UpdateRental
   * @request PATCH:/leasing/kiosks/{kioskId}/rentals/{rentalId}
   * @secure
   * @response `200` `KioskResponse` OK
   */
  updateRental = (
    kioskId: string,
    rentalId: string,
    data: RentalRequestWithFiles,
    params: RequestParams = {},
  ) =>
    this.request<KioskResponse, any>({
      path: `/leasing/kiosks/${kioskId}/rentals/${rentalId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags kiosk-controller
   * @name DownloadRentalContracts
   * @request GET:/leasing/kiosks/{kioskId}/rentals/{rentalId}/contracts
   * @secure
   * @response `200` `StreamingResponseBody` OK
   */
  downloadRentalContracts = (
    kioskId: string,
    rentalId: string,
    params: RequestParams = {},
  ) =>
    this.request<Blob, any>({
      path: `/leasing/kiosks/${kioskId}/rentals/${rentalId}/contracts`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags kiosk-controller
   * @name UpdateRentalContracts
   * @request PATCH:/leasing/kiosks/{kioskId}/rentals/{rentalId}/contracts
   * @secure
   * @response `200` `KioskResponse` OK
   */
  updateRentalContracts = (
    kioskId: string,
    rentalId: string,
    data: RentalContractRequest,
    params: RequestParams = {},
  ) =>
    this.request<KioskResponse, any>({
      path: `/leasing/kiosks/${kioskId}/rentals/${rentalId}/contracts`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags kiosk-controller
   * @name DownloadRentalAuthorizations
   * @request GET:/leasing/kiosks/{kioskId}/rentals/{rentalId}/authorizations
   * @secure
   * @response `200` `StreamingResponseBody` OK
   */
  downloadRentalAuthorizations = (
    kioskId: string,
    rentalId: string,
    params: RequestParams = {},
  ) =>
    this.request<Blob, any>({
      path: `/leasing/kiosks/${kioskId}/rentals/${rentalId}/authorizations`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags kiosk-controller
   * @name UpdateRentalAuthorizations
   * @request PATCH:/leasing/kiosks/{kioskId}/rentals/{rentalId}/authorizations
   * @secure
   * @response `200` `KioskResponse` OK
   */
  updateRentalAuthorizations = (
    kioskId: string,
    rentalId: string,
    data: RentalAuthorizationRequest,
    params: RequestParams = {},
  ) =>
    this.request<KioskResponse, any>({
      path: `/leasing/kiosks/${kioskId}/rentals/${rentalId}/authorizations`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags kiosk-controller
   * @name DownloadKioskPictures
   * @request GET:/leasing/kiosks/{kioskId}/pictures
   * @secure
   * @response `200` `StreamingResponseBody` OK
   */
  downloadKioskPictures = (kioskId: string, params: RequestParams = {}) =>
    this.request<Blob, any>({
      path: `/leasing/kiosks/${kioskId}/pictures`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags kiosk-controller
   * @name UpdateKioskPictures
   * @request PATCH:/leasing/kiosks/{kioskId}/pictures
   * @secure
   * @response `200` `KioskResponse` OK
   */
  updateKioskPictures = (
    kioskId: string,
    data: KioskPictureRequest,
    params: RequestParams = {},
  ) =>
    this.request<KioskResponse, any>({
      path: `/leasing/kiosks/${kioskId}/pictures`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags kiosk-controller
   * @name UpdateKioskStatus
   * @request PATCH:/leasing/kiosks/{id}/status
   * @secure
   * @response `200` `KioskResponse` OK
   */
  updateKioskStatus = (
    id: string,
    data: KioskStatusRequest,
    params: RequestParams = {},
  ) =>
    this.request<KioskResponse, any>({
      path: `/leasing/kiosks/${id}/status`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags leasing-client-controller
   * @name GetLeasingClientById
   * @summary Get Leasing Client by ID
   * @request GET:/leasing/clients/{clientId}
   * @secure
   * @response `200` `LeasingClientResponse` OK
   */
  getLeasingClientById = (clientId: string, params: RequestParams = {}) =>
    this.request<LeasingClientResponse, any>({
      path: `/leasing/clients/${clientId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags leasing-client-controller
   * @name DeleteLeasingClient
   * @request DELETE:/leasing/clients/{clientId}
   * @secure
   * @response `200` `LeasingClientResponse` OK
   */
  deleteLeasingClient = (clientId: string, params: RequestParams = {}) =>
    this.request<LeasingClientResponse, any>({
      path: `/leasing/clients/${clientId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags leasing-client-controller
   * @name UpdateLeasingClient
   * @request PATCH:/leasing/clients/{clientId}
   * @secure
   * @response `200` `LeasingClientResponse` OK
   */
  updateLeasingClient = (
    clientId: string,
    data: LeasingClientRequest,
    params: RequestParams = {},
  ) =>
    this.request<LeasingClientResponse, any>({
      path: `/leasing/clients/${clientId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags kiosk-controller
   * @name DownloadRentalContract
   * @request GET:/leasing/kiosks/{kioskId}/rentals/{rentalId}/contracts/{documentId}
   * @secure
   * @response `200` `File` OK
   */
  downloadRentalContract = (
    kioskId: string,
    rentalId: string,
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<Blob, any>({
      path: `/leasing/kiosks/${kioskId}/rentals/${rentalId}/contracts/${documentId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags kiosk-controller
   * @name DeleteRentalContract
   * @request DELETE:/leasing/kiosks/{kioskId}/rentals/{rentalId}/contracts/{documentId}
   * @secure
   * @response `200` `KioskResponse` OK
   */
  deleteRentalContract = (
    kioskId: string,
    rentalId: string,
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<KioskResponse, any>({
      path: `/leasing/kiosks/${kioskId}/rentals/${rentalId}/contracts/${documentId}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags kiosk-controller
   * @name DownloadRentalAuthorization
   * @request GET:/leasing/kiosks/{kioskId}/rentals/{rentalId}/authorizations/{documentId}
   * @secure
   * @response `200` `File` OK
   */
  downloadRentalAuthorization = (
    kioskId: string,
    rentalId: string,
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<Blob, any>({
      path: `/leasing/kiosks/${kioskId}/rentals/${rentalId}/authorizations/${documentId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags kiosk-controller
   * @name DeleteRentalAuthorization
   * @request DELETE:/leasing/kiosks/{kioskId}/rentals/{rentalId}/authorizations/{documentId}
   * @secure
   * @response `200` `KioskResponse` OK
   */
  deleteRentalAuthorization = (
    kioskId: string,
    rentalId: string,
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<KioskResponse, any>({
      path: `/leasing/kiosks/${kioskId}/rentals/${rentalId}/authorizations/${documentId}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags kiosk-controller
   * @name DownloadKioskPicture
   * @request GET:/leasing/kiosks/{kioskId}/pictures/{documentId}
   * @secure
   * @response `200` `File` OK
   */
  downloadKioskPicture = (
    kioskId: string,
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<Blob, any>({
      path: `/leasing/kiosks/${kioskId}/pictures/${documentId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags kiosk-controller
   * @name DeleteKioskPicture
   * @request DELETE:/leasing/kiosks/{kioskId}/pictures/{documentId}
   * @secure
   * @response `200` `KioskResponse` OK
   */
  deleteKioskPicture = (
    kioskId: string,
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<KioskResponse, any>({
      path: `/leasing/kiosks/${kioskId}/pictures/${documentId}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags kiosk-controller
   * @name GetHistory3
   * @request GET:/leasing/kiosks/history/{resourceId}
   * @secure
   * @response `200` `(AuditResponse)[]` OK
   */
  getHistory3 = (resourceId: string, params: RequestParams = {}) =>
    this.request<AuditResponse[], any>({
      path: `/leasing/kiosks/history/${resourceId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags kiosk-controller
   * @name DeleteRentalAttachment
   * @request DELETE:/leasing/kiosks/{kioskId}/rentals/{rentalId}/documents/{documentId}
   * @secure
   * @response `200` `KioskResponse` OK
   */
  deleteRentalAttachment = (
    kioskId: string,
    rentalId: string,
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<KioskResponse, any>({
      path: `/leasing/kiosks/${kioskId}/rentals/${rentalId}/documents/${documentId}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });
}
